import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import ArticleCard from "@/components/base/ArticleCard";

export default function LatestArticles() {
  const latestArticles = articles.slice(0, 6);

  return (
    <section className="py-14 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              最新文章
            </h2>
            <p className="text-foreground-600 text-sm">
              持续更新优质内容，发现更多精彩
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {latestArticles.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
        <div className="mt-10 text-center">
          <Link
            to="/category/tools"
            className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 border border-background-300/60 text-foreground-800 rounded-full text-sm font-medium hover:bg-background-200/70 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-archive-line"></i>
            浏览更多内容
          </Link>
        </div>
      </div>
    </section>
  );
}